import { FormInlineErrorModule } from '../../shared/component/form-inline-error/form-inline-error.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordResetPageComponent } from './password-reset-page.component';
import { SharedComponentsModule } from 'src/app/shared/modules/sharedComponentsModule';


@NgModule({
    declarations: [
        PasswordResetPageComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FormInlineErrorModule,
        SharedComponentsModule
    ],
    exports: [PasswordResetPageComponent]
})
export class PasswordResetPageModule {}
